module.exports = __webpack_public_path__ + "static/img/materials6.6e963d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materials6.jpg
// module id = Ylgu
// module chunks = 1